import { blogsService, commonZonesService, get_service, constructionCompaniesService } from './feathers-rest';
export const getService = service => get_service(service);


export { blogsService, commonZonesService, constructionCompaniesService };
